import React, { createContext, useContext, useEffect, useState } from "react";
import { http } from "@/lib/api";

const AuthCtx = createContext({ user: null, ready: false, login: async () => {}, logout: async () => {} });

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [ready, setReady] = useState(false);

    useEffect(() => {
        let active = true;
        // Only attempt session check on admin routes to avoid 401 noise on public pages
        if (!window.location.pathname.startsWith("/admin")) {
            setReady(true);
            return () => {
                active = false;
            };
        }
        http.get("/auth/me")
            .then((r) => active && setUser(r.data))
            .catch(() => active && setUser(null))
            .finally(() => active && setReady(true));
        return () => {
            active = false;
        };
    }, []);

    const login = async (email, password) => {
        const { data } = await http.post("/auth/login", { email, password });
        setUser({ email: data.email, name: data.name, role: data.role });
        return data;
    };

    const logout = async () => {
        try {
            await http.post("/auth/logout");
        } catch (err) {
            console.warn("logout failed:", err?.message || err);
        }
        setUser(null);
    };

    return <AuthCtx.Provider value={{ user, ready, login, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
